// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"2947":"StudentTransactions","3090":"AssignHomework"}[chunkId] || chunkId) + "." + {"2947":"44cb6f17","3090":"44cb6f17","8662":"15f6c673"}[chunkId] + ".chunk.css";
};